import { valueof } from '@flipster/utils/typescript';

import { Timestamp } from '../../types';

export interface TradingCompetitionsParams {
  competitionType?: 'GENERAL' | 'SYMBOL_CHAMPIONS' | 'WEEKLY_PNL' | 'NEW_LISTING';
}

export type TradingCompetitionType =
  | 'GENERAL'
  | 'SYMBOL_CHAMPIONS'
  | 'WEEKLY_PNL'
  | 'NEW_LISTING'
  | 'HOSTED_BY_INFLUENCER';

export interface TradingCompetition {
  competitionType: TradingCompetitionType;
  competitionUrl: string;
  bannerUrls: {
    desktop: string;
    mobile: string;
  };
  title: string;
  totalTradingVolume?: string;
  backgroundColorBanner: string;
  backgroundColorLeft: string;
  backgroundColorRight: string;
  prizePool: string;
  currentMilestonePrizePool?: string;
  milestone?: {
    prizePool: string;
    requiredTradingVolume: string;
  }[];
  registrationStartTime: string;
  registrationEndTime: string;
  competitionStartTime: string;
  competitionEndTime: string;
  competitionStatus: CompetitionStatusType;
  registrationStatus: CompetitionStatusType;
  noticeMarkdown: string;
  participationTime?: string;
  rankBy: RankByType;
  isLeaderboardVisible: boolean;
  // User cannot join other competition if user joined exclusive competition
  isExclusive: boolean;
  hostName?: string;
  // Whether user need invitation code to register competition
  needInvitationCode: boolean;
  meta: {
    title?: string;
    description?: string;
  };
  recurringLastWeekChampion?: {
    nickname: string;
    prize: string;
  };
  claimRequiredForReward?: boolean;
  claimedTime?: string;
}

export interface TradingCompetitionRankings {
  lastUpdatedTime?: string;
  myRanking?: Ranking;
  rankings: Ranking[];
  lastRanking?: Ranking;
}

export interface Ranking {
  userId: number;
  userProfileId: string;
  nickname: string;
  rank: number;
  rankingStatus: RankingStatusType;
  pnl: string;
  volume: string;
}

export interface RegisteredTradingCompetition {
  competitionUrl?: string;
  myRanking?: Ranking;
  numParticipants?: number;
  competitionStartTime?: string;
  competitionEndTime?: string;
  lastUpdatedTime?: string;
  updateIntervalInMin: number;
}

export interface PostTradingCompetitionRegisterationParams {
  invitationCode?: string;
}

export const CompetitionStatusEnum = {
  Upcoming: 'UPCOMING',
  Ongoing: 'ONGOING',
  Finished: 'FINISHED',
  Canceled: 'CANCELED',
} as const;

export const RankingStatusEnum = {
  Fulfilled: 'FULFILLED',
  Unfulfilled: 'UNFULFILLED',
  DeregisteredByUser: 'DEREGISTERED_BY_USER',
  DeregisteredByAdmin: 'DEREGISTERED_BY_ADMIN',
} as const;

export const RankByEnum = {
  Pnl: 'PNL',
  Volume: 'VOLUME',
} as const;

export type CompetitionStatusType = valueof<typeof CompetitionStatusEnum>;
export type RankByType = valueof<typeof RankByEnum>;
export type RankingStatusType = valueof<typeof RankingStatusEnum>;

export interface SquadCompetition {
  competitionUrl: string;
  competitionStartTime: Timestamp;
  competitionEndTime: Timestamp;
  title: string;
  rules: string[];
  rankBy: RankByType;
  prizePool: string;
  rankings: SquadCompetitionRanking[];
  rankingsLastUpdatedAt?: Timestamp;
  mySquadName: string;
  mySquadUrl: string;
  meta: {
    title: string;
    description: string;
  };
}

export interface SquadCompetitionRanking {
  squadName: string;
  squadUrl: string;
  rank?: number;
  pnl?: string;
  volume?: string;
}
